import React, { ReactNode, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const ContentWrapper = styled.div`
  overflow: hidden;
  transition: height 0.3s ease;
`;

interface IAnimateContentHeight {
  open: boolean;
  children: ReactNode;
}

const AnimateContentHeight = ({ open, children }: IAnimateContentHeight) => {
  const [contentHeight, setContentHeight] = useState(0);
  const contentWrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open && contentWrapper.current) {
      setContentHeight(contentWrapper.current.scrollHeight);
    } else {
      setContentHeight(0);
    }
  }, [open]);

  return (
    <ContentWrapper ref={contentWrapper} style={{ height: contentHeight }}>
      {children}
    </ContentWrapper>
  );
};

export default AnimateContentHeight;
